import { render, staticRenderFns } from "./QRCodeDialog.vue?vue&type=template&id=052fc638&scoped=true"
import script from "./QRCodeDialog.vue?vue&type=script&lang=js"
export * from "./QRCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./QRCodeDialog.vue?vue&type=style&index=0&id=052fc638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fc638",
  null
  
)

export default component.exports